const TRIAL_PACKAGES = new Set(["pro_monthly", "pro_annual"]);

export const TRIAL_PLAN_SELECTION_PATH = "/pricing?trial_signup=1";

export const validTrialPackage = (packageId) =>
  TRIAL_PACKAGES.has(packageId) ? packageId : null;

export const trialResumePath = (packageId) => {
  const valid = validTrialPackage(packageId);
  return valid ? `/pricing?checkout=${valid}` : "/pricing";
};

export const trialSignupPath = (packageId) =>
  `/login?signup=1&next=${encodeURIComponent(trialResumePath(packageId))}`;

export const trialPackageFromSearch = (search = "") => {
  const params = new URLSearchParams(search);
  return validTrialPackage(params.get("checkout"));
};

// Registration creates a Free member without a card. Preserve a safe in-app
// destination so someone saving a routine or explicitly choosing Pro returns
// to that intent; otherwise start their personalized onboarding.
export const newTrialSignupDestination = (requestedPath = "") => {
  try {
    const url = new URL(requestedPath || "/", "https://trubeaute.com");
    if (url.origin !== "https://trubeaute.com") {
      return "/onboarding";
    }
    if (url.pathname === "/" || url.pathname === "/login") return "/onboarding";
    if (url.pathname === "/pricing") {
      const packageId = validTrialPackage(url.searchParams.get("checkout"));
      return packageId ? trialResumePath(packageId) : "/pricing";
    }
    return `${url.pathname}${url.search}${url.hash}`;
  } catch {
    return "/onboarding";
  }
};
